















export default {
  props: {
    feedbackMoreWorkLoad: {
      validator: prop => typeof prop === 'boolean' || prop === null,
      required: true,
    },
    center: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      buttons: [
        {
          label: 'NO',
          value: false,
        },
        {
          label: 'YES',
          value: true,
        },
      ],
    }
  },
}
